module.exports = __webpack_public_path__ + "static/turquia-026.thumb-db8bf3b4f30439b5f24e4b22a13bb9c3.jpg";